import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class LocationListService {
    public lastUpdateFromTimer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _currentMapUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _openedWindows: { [key: string]: Window } = {};

    setCurrentMapUrl(url: string) {
        this._currentMapUrl.next(url);
    }

    getCurrentMapUrl(): string {
        return this._currentMapUrl.value;
    }

    setOpenedWindow(tabName: string, window: Window) {
        this._openedWindows[tabName] = window;
    }

    getOpenedWindow(tabName: string): Window | undefined {
        return this._openedWindows[tabName];
    }

}
